import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Redirect, Route, Switch } from 'react-router-dom';

import brandLogo from './../../images/brand-logo-inverse-dark.png';

let cancelToken;

class AgradecimientoContainer extends Component {

    render = () => {
        return (
            <div className="container-agradecimiento">
                <div id="" className="container-box-agredecimiento">
                    <div className="store-singup">
                        <div className="panel panel-default panel-agredecimiento">
                            <div className="panel-content">
                                <div className="panel-header">                                    
                                </div>
                                <div className="form-group panel-body">
                                    <h2 className="text-header">
                                        ¡Gracias por tu compra!
                                    </h2>
                                    <h5 className="text-body">
                                        En los proximos dias te llegará un correo mencionando los pasos a seguir
                                    </h5>
                                </div>
                                <div className="form-group panel-button">
                                    <button
                                        className="btn btn-primary btn-agredecimiento"
                                        onClick={() => window.location.replace("/")}>
                                        VISITA NUESTRA PAGINA
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(AgradecimientoContainer);


// WEBPACK FOOTER //
// ./src/guest/summit/AgradecimientoContainer.js